import {
  CampaignSubTypeName,
  CampaignTypeName,
  NonSocialCampaignSubTypeName,
  SocialCampaignSubTypeName,
} from '../campaigns.types';

function getDefaultSubtype(campaignType: CampaignTypeName): CampaignSubTypeName {
  switch (campaignType) {
    case CampaignTypeName.SnapchatAds:
      return SocialCampaignSubTypeName.SnapchatStandard;
    case CampaignTypeName.FacebookVideoAds:
      return SocialCampaignSubTypeName.FacebookStandard;
    case CampaignTypeName.TikTokAds:
      return SocialCampaignSubTypeName.TiktokStandard;
    case CampaignTypeName.YoutubeVideoAds:
      return SocialCampaignSubTypeName.YoutubeGoogleAds;
    case CampaignTypeName.LinkedInAds:
      return SocialCampaignSubTypeName.LinkedInStandard;
    case CampaignTypeName.MockSocial:
      return SocialCampaignSubTypeName.MockSocialStandard;
    default:
      return NonSocialCampaignSubTypeName.NONE;
  }
}

export default getDefaultSubtype;
